import { Shadow, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { ResponsesPensionItemResponse } from '@genial/services/dist/models';
import { Box, FlatList } from 'native-base';
import React from 'react';

import { LateralBar } from '../../../../../../../NewApplication/Product/components/LateralBar';

import { FundPensionItem } from './components/FundPensionItem';
import { PlanDetails } from './components/PlanDetails';
import { parsePlanDetailsData } from './constants';

interface PensionItemProps {
  data: ResponsesPensionItemResponse;
}

const ItemSeparatorComponent = () => <Box h={Spacing['inset.nano']} />;

export const PensionItem: React.FC<PensionItemProps> = ({ data }) => {
  const planDetailsData = parsePlanDetailsData(data);

  return (
    <Shadow level={3} borderRadius={BoxRadius.sm} my={Spacing['inline.nano']}>
      <VStack borderRadius={BoxRadius.sm}>
        <LateralBar
          backgroundColor={Color['product.previdencia']}
          borderTopLeftRadius={BoxRadius.sm}
          borderBottomLeftRadius={BoxRadius.sm}
        />
        <VStack p={Spacing['inline.xxxs']} space={Spacing['inline.xxxs']}>
          <PlanDetails data={planDetailsData} />
          <FlatList
            data={data.funds}
            ItemSeparatorComponent={ItemSeparatorComponent}
            keyExtractor={(keyItem, index) => `${keyItem.cnpj}-${index}`}
            renderItem={({ item }) => <FundPensionItem item={item} />}
          />
        </VStack>
      </VStack>
    </Shadow>
  );
};
